// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1dfGo","title":"AfterFrontImage_title__2CL_R"};